<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" outlined dense label="车牌号" clearable></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-select outlined dense v-model="queryForm.own_type" label="车辆类型" :items="own_types" clearable
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无"></v-select>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" dark tile @click="getdata('download')">
            <v-icon small>mdi-download</v-icon> {{ queryForm.tab === 1 ? '下载能耗数据' : '下载补能数据' }}
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.tab" size="small" @change="onTabChange">
      <a-tab-pane :key="1" tab="能耗管理"></a-tab-pane>
      <a-tab-pane :key="2" tab="补能统计"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
      </a-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "EnergyConsumption",
  data() {
    return {
      start_day_menu: false,
      end_day_menu: false,
      queryForm: {
        tab: 1,
        start_day: "",
        end_day: "",
        vehicle_number: "",
        own_type: null,
      },
      own_types: [
        { text: "自有车", value: 1 },
        { text: "包车", value: 3 },
      ],
      // 能耗管理表头
      headers1: [
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 140, align: "center" },
        { title: "总越次", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 100, align: "center" },
        { title: "线路", dataIndex: "postline", scopedSlots: { customRender: "postline" }, width: 200, align: "center" },
        { title: "总里程数(KM)", dataIndex: "mileage", scopedSlots: { customRender: "mileage" }, width: 140, align: "center" },
        { title: "总能耗", dataIndex: "used", scopedSlots: { customRender: "used" }, width: 200, align: "center" },
        { title: "平均能耗", dataIndex: "avg", scopedSlots: { customRender: "avg" }, width: 180, align: "center" },
      ],
      // 补能统计表头
      headers2: [
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 140, align: "center" },
        { title: "补能地点", dataIndex: "location", scopedSlots: { customRender: "location" }, width: 200, align: "center" },
        { title: "补能次数", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 170, align: "center" },
        { title: "补能(电量/油量)", dataIndex: "qty", scopedSlots: { customRender: "qty" }, width: 160, align: "center" },
        { title: "金额", dataIndex: "amount", scopedSlots: { customRender: "amount" }, width: 130, align: "center" },
        { title: "单价", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 120, align: "center" },
      ],
      list: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    headers() {
      return this.queryForm.tab === 1 ? this.headers1 : this.headers2;
    },
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.list = [];
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      tab: 1,
      start_day,
      end_day,
      vehicle_number: "",
      own_type: null,
    };
    this.getdata();
  },
  methods: {
    onTabChange() {
      this.list = [];
      this.getdata();
    },
    getdata(action) {
      if (this.MOCK_MODE) {
        this.getMockData();
        return;
      }
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/energyconsumption/list", {
        ...this.queryForm,
        action,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === 'download') {
            return this.$download(res.data.url, res.data.name);;
          }
          this.list = res.data.list;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
